export default "__VITE_ASSET__DDkhfYM2__"